<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_6"></a>DEDICATION</h2>
<p class="noindent"><span class="dropcap">I</span> dedicate this book to my late wife, Velda Margaret (nee Kirton), a native of Hayes, Middlesex. On leaving school in 1948, she became a shorthand-typist with the newly formed Western Region of British Railways at Paddington, in succession to the Great Western Railway, where she began work in the Rates department. She aspired to become a secretary to one of the officers and eventually to becoming a relief secretary whose duties included relieving the General Manager’s secretary for annual leave, etc. One of her other duties was assisting the board member in charge of what remained of the Fishguard &amp; Rosslare company’s business during the 1950s, involving typing, book-keeping and general matters, thus having a link with the Fishguard element of this book. It was during this time that she worked with Eva MacDonald of Iver who also worked in the Rates department and who became a well-known historical romance novelist, an autographed copy of the whole of the 38 volumes of her works now residing in one of my bookcases.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?1d92fd4c